import { ITransaction } from "../types";

const transactionComparator = (a: ITransaction, b: ITransaction): number => {
    return b.time.getTime() - a.time.getTime();
};

export default transactionComparator;
